import { profileformatDate } from '@/lib/postFunctions'
import { Case, SmartLink } from '@/payload-types'
import SmartLinksComponent from '../smart-links/smartLinks'

interface IProps {
  caseData: Case
}

export function CaseDetails({ caseData }: IProps) {
  const details = [
    {
      label: 'Date',
      value: caseData.date ? profileformatDate(caseData.date) : null,
    },
    {
      label: 'Organizers',
      value: caseData.organizations
        ? caseData.organizations.map((org) => typeof org === 'object' && org.name).join(', ')
        : null,
    },
    {
      label: 'Location',
      value: caseData.address || null,
    },
  ]

  const smartLink: SmartLink = {
    screenshot: caseData.coverimage ? [caseData.coverimage] : [],
    externalLink: caseData.flyerLink,
    textToDisplay: caseData.flyerSource,
    blockType: 'smartlink',
  }

  return (
    <div>
      {details.map(
        ({ label, value }) =>
          value && (
            <span key={label}>
              <p>
                <strong>{label}:</strong>
                {' ' + value}
              </p>
            </span>
          ),
      )}
      <div>
        {caseData.flyerSource && caseData.coverimage && caseData.flyerLink && (
          <span>
            <strong>Event Flyer: </strong>
            <SmartLinksComponent text={[caseData.flyerSource]} smartLink={smartLink} />
          </span>
        )}
      </div>
    </div>
  )
}
